export const paragraphTitle="At Vehicle Learning Innovation (VLI), we’re redefining the way vehicle learner education is managed digitally. Our mission is simple to ensure ethical practices and to connect trusted vehicle training institutes with modern learners through a centralized, state of the art digital platform powered by AI, built for efficiency, growth, and safety."

export const paragraph2="Founded with the vision to digitize and modernize the traditional vehicle training education system globally, VLI serves as a powerful bridge between institutions and learners. We facilitate and empower MOT-approved vehicle training institutes to bring their programs digitally, while giving learners the platform to find, compare, enroll, monitor and succeed with confidence."

 export const aboutList=[


    {
      key: 1,
      title: "Our Vision",
      description: "To become World's most trusted, digital and innovative platform in which government approved vehicle training institute and learner will follow world best guidelines and practices to reduce fatal accidents and road-safety risks by making professional training more accessible, trackable, and transparent for every learner, everywhere.",
      description2: null,
      
    },
    {
      key:2,
      title: "Our Mission",
      description:"To promote ethical and empowered vehicle training institutes with cutting-edge digital tools, and provide learners with seamless access to authentic, high-quality training programs — all while driving down risks on the road through informed, data-driven learning experiences.",
      description2: null,

    },

    {
        key:3,
        title:"Why VLI Matters",
        description:"Every year, thousands of lives are affected by avoidable road accidents due to poor training and lack of access to quality instruction. At VLI, we envision a future where technology plays a critical role in saving lives, by making vehicle training education more effective, accessible, and accountable.",
        description2: " By digitizing the traditional learning model, we’re not only simplifying operations for training institutes — we’re equipping the next generation of drivers/operators with the MOT approved and high quality training that will boost confidence to drive safely, responsibly, and skillfully."

        
    },
]